import axios from 'axios';

// Dedicated axios instance for HR Assistant endpoints.
const hrApi = axios.create({ baseURL: '/api/hr', withCredentials: true });

hrApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

hrApi.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      const onLogin = window.location.pathname === '/login';
      if (!onLogin) {
        localStorage.removeItem('flowup_token');
        window.dispatchEvent(new CustomEvent('auth:logout'));
        setTimeout(() => { window.location.replace('/login'); }, 100);
      }
    }
    return Promise.reject(err.response?.data || { error: err.message });
  }
);

export default hrApi;
